import React, { Component, createRef } from "react";
import moment from "moment/moment";
// // Editable
import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory, { Type } from "react-bootstrap-table2-editor";

import { Card, Col, Container, Row } from "reactstrap";

import { Link } from "react-router-dom";
import { withTranslation } from "react-i18next";
//Import Breadcrumb
import Breadcrumbs from "../Common/Breadcrumb";
import {
  assignGraderToFillerInWardsRepeats,
  assignGraderToFillerRejectStocks,
  assignGraderToFillerStocks,
  getDataEntryStock,
  getFillerStock,
  getGraderDashboard,
  getGraderInwardStock,
  getGraderPendingStock,
  getGraderRejectStock,
  getGraderStock,
} from "api";
import RaisedButton from "components/Common/RaisedButton";
import ShowDifferenceTable from "components/Common/ShowDiffenenceTable";

class GraderDashboard extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      validation: "",
      editRowIndex: -1,
      fillerRejectStockList: [],
      dataEntryStockList: [],
      inwardDataEntryStockList: [],
      dashboardInfo: "",
      pendingStockList: [],
      repeatStockList: [],
      repeatRejectStockList: [],
      rejectStockList: [],
    };
  }

  async componentDidMount() {
    const dashboard = await getGraderDashboard();
    if (dashboard && dashboard.data) {
      this.setState({
        dashboardInfo: dashboard.data,
      });
    }
    const pendingStockList = await getDataEntryStock({
      page: null,
      limit: null,
      graderStatus: "P",
      graderUserId: JSON.parse(localStorage.getItem("authUser")).id,
    });
    if (pendingStockList && pendingStockList.data) {
      this.setState({
        pendingStockList:
          pendingStockList.data.dataEntryStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : pendingStockList.data.dataEntryStocks,
      });
    }
    const rejectStockList = await getDataEntryStock({
      page: null,
      limit: null,
      graderStatus: "R",
    });
    if (rejectStockList && rejectStockList.data) {
      this.setState({
        rejectStockList:
          rejectStockList.data.dataEntryStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : rejectStockList.data.dataEntryStocks,
      });
    }
    const inwardStockList = await getGraderStock({ page: 1, limit: 5 });
    if (inwardStockList && inwardStockList.data) {
      this.setState({
        inwardDataEntryStockList:
          inwardStockList.data.graderStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : inwardStockList.data.graderStocks,
      });
    }
    const fillerRejectStockList = await getGraderStock({
      page: null,
      limit: null,
      fillerStatus: "R",
    });
    if (fillerRejectStockList && fillerRejectStockList.data) {
      this.setState({
        fillerRejectStockList:
          fillerRejectStockList.data.graderStocks.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : fillerRejectStockList.data.graderStocks,
      });
    }
    const repeatStock = await assignGraderToFillerInWardsRepeats({
      page: 1,
      limit: 5
    });
    if (repeatStock && repeatStock.data) {
      this.setState({
        repeatStockList:
          repeatStock.data.assignGraderToFillerInWards.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : repeatStock.data.assignGraderToFillerInWards,
      });
    }
    const repeatRejectStock = await assignGraderToFillerInWardsRepeats({
      page: 1,
      limit: 5,
      dataEntryStatus: "R",
    });

    if (repeatRejectStock && repeatRejectStock.data) {
      this.setState({
        repeatRejectStockList:
          repeatRejectStock.data.assignGraderToFillerInWards.length == 0
            ? [
                {
                  id: "0",
                  jangad: {
                    cycle: 0,
                    weight: 0,
                    pieces: 0,
                    createdAt: "0",
                    factory: {
                      name: "0",
                    },
                  },
                  dataEntryGraderUser: {
                    name: "0",
                  },
                  processId: 0,
                  mainJangad: {
                    name: "0",
                    party: {
                      name: "0",
                    },
                  },
                  stockDataEntryInWard: {
                    srNo: 0,
                    pieces: 0,
                  },
                  partyName: "0",
                  weight: 0,
                  pieces: 0,
                  cycle: 0,
                  createdAt: "",
                },
              ]
            : repeatRejectStock.data.assignGraderToFillerInWards,
      });
    }
  }

  render() {
    this.columns3 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(x => x.ar).length;
          console.log(tot)
          
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
           return <ShowDifferenceTable a={row.stockDataEntryInWards} b={row.jangad} f="weight" />

        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/grader-edit-verify-accept",
                    query: {
                      isEdit: 1,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    this.columns4 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        hidden:true
      },
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        }
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        style: { width: "120px" },
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(
            x => x.ar
          ).length;
          ;
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style: { width: "130px" },
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards
            ?.filter(x => x.ar)
            .reduce((acc, item) => acc + item.weight, 0)
            .toFixed(2);
          {
            return tot == row.jangad.weight ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.weight}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.weight}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <div className="btn-group">
              <Link
                to={{
                  pathname: "/grader-assign-screen2",
                  query: {
                    isEdit: 2,
                    data: row,
                  },
                }}
              >
                <button className="py-2 px-2 border-0 rounded">
                  <img src="images/dashboard-images/edit.svg" />
                </button>
              </Link>
            </div>
          ),
      },
    ];

    this.columns1 = [
      {
        dataField: "id",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        hidden: true,
      },
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        style:{width:"120px"},
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(x => x.ar).length;
          
          {
            return tot == row?.dataEntryStock?.stockDataEntryInWards?.length ? (
              <div className="d-flex justify-content-start pe-3">
                <div>{row.jangad.pieces}</div>
              </div>
            ) : (
              <div className="d-flex justify-content-between pe-3">
                <div>{row.jangad.pieces}</div>

                <div className="text-danger">({tot})</div>
              </div>
            );
          }
        },
      },
      {
        dataField: "weight",
        style:{width:"130px"},
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          let tot = row?.dataEntryStock?.stockDataEntryInWards?.filter(x => x.ar)
          .reduce((acc, item) => acc + item.weight, 0)
          .toFixed(2);

        {
          return tot == row.jangad.weight ? (
            <div className="d-flex justify-content-start pe-3">
              <div>{row.jangad.weight}</div>
            </div>
          ) : (
            <div className="d-flex justify-content-between pe-3">
              <div>{row.jangad.weight}</div>

              <div className="text-danger">({tot})</div>
            </div>
          );
        }
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              {row.assignGraderToFillerStock?.fillerStatus != "A" ? (
                <div className="btn-group">
                  <Link
                    to={{
                      pathname: "/grader-assign-screen2",
                      query: {
                        isEdit: 2,
                        data: row,
                      },
                    }}
                  >
                    <button className="py-2 px-2 border-0 rounded">
                      <img src="images/dashboard-images/edit.svg" />
                    </button>
                  </Link>
                </div>
              ) : (
                ""
              )}
            </>
          ),
      },
    ];

    this.columns2 = [
      {
        dataField: "id",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.jangad.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return row.jangad.weight;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return row.jangad.cycle;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(row.jangad.createdAt).format("DD/MM/YYYY");
        },
        sort: true,
      },
    ];

    this.columns5 = [
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },
      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.stockDataEntryInWard.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return cell;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return cell;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter(cell, row) {
          return row.process?.name;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(cell).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/grader-reassign",
                    state: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    this.columns6 = [
      {
        dataField: "mainJangadId",
        text: `${this.props.t("Jangad Id")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.name;
        },
      },
      {
        dataField: "partyCode",
        text: `${this.props.t("Party Code")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.mainJangad.party.partyCode;
        },
      },
      {
        dataField: "srNo",
        text: `${this.props.t("Sr.No.")}`,
        sort: true,
        formatter: (cell, row) => {
          return row.stockDataEntryInWard.srNo;
        },
      },

      {
        dataField: "pieces",
        text: `${this.props.t("Pieces")}`,
        sort: true,
        formatter(cell, row) {
          return row.stockDataEntryInWard.pieces;
        },
      },
      {
        dataField: "weight",
        text: `${this.props.t("Weight")}`,
        sort: true,
        formatter(cell, row) {
          return cell;
        },
      },

      {
        dataField: "cycle",
        text: `${this.props.t("Cycle")}`,
        formatter(cell, row) {
          return cell;
        },
      },
      {
        dataField: "processId",
        text: `${this.props.t("Process")}`,
        formatter(cell, row) {
          return row.process?.name;
        },
      },
      {
        dataField: "createdAt",
        text: `${this.props.t("Inward Date")}`,
        formatter(cell, row) {
          return moment(cell).format("DD/MM/YYYY");
        },
        sort: true,
      },
      {
        dataField: "viewdetail",
        text: `${this.props.t("View Details")}`,
        formatter: (cell, row) =>
          row.weight == 0 ? (
            ""
          ) : (
            <>
              <div className="btn-group">
                <Link
                  to={{
                    pathname: "/grader-reassign",
                    query: {
                      isEdit: 2,
                      data: row,
                    },
                  }}
                >
                  <button className="py-2 px-2 border-0 rounded">
                    <img src="images/dashboard-images/edit.svg" />
                  </button>
                </Link>
              </div>
            </>
          ),
      },
    ];

    const defaultForCycleSorted = [
      {
        dataField: "cycle",
        order: "asc",
      },
    ];

    document.title = "grader flow";
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Grader Dashboard")} />

            <div className="row">
              <div className="col-xl-4 col-12">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("To Receive / Pending List")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.pending}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3 mt-xl-0">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Received/My Stock")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.received}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 mt-3 mt-xl-0">
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Forward to Filler")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.forwardToFiller}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 pt-5">
                <h3 className="fw-bold text-black pb-3 text-center text-md-start">
                  {this.props.t("In Testing/QA")}
                </h3>
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("In Testing")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.inTesting}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 pt-5">
                <h3 className="fw-bold text-black pb-3 text-center text-md-start">
                  {this.props.t("Completed (Inward)")}
                </h3>
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Get From DataEntry")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.inWard}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4 col-12 pt-5">
                <h3 className="fw-bold text-black pb-3 text-center text-md-start">
                  {this.props.t("Completed (Outward)")}
                </h3>
                <div className="bg-white main_hero_section_sub mt-4 mt-lg-0 py-4 px-2">
                  <div className="row">
                    <div className="col-sm-8 text-center text-md-start ps-0 ps-sm-4">
                      <h5 className="pt-3 text-dark fs-3">
                        {this.props.t("Forward To DataEntry")}
                      </h5>
                      <h3 className="pt-2 text-black">
                        {this.state.dashboardInfo.outWard}
                      </h3>
                    </div>
                    <div className="col-sm-4">
                      <img
                        src="images/dashboard-images/dailyinward.svg"
                        className="img-fluid mx-auto d-block mt-3"
                        alt="daily inward image"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Pending List")}{" "}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.pendingStockList}
                    columns={this.columns3}
                  />
                </div>
              </Card>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Inward List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.inwardDataEntryStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card>
            </div>

            {/* <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">{this.props.t('Repeat Stock List')}</h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.inwardDataEntryStockList}
                    columns={this.columns1}
                  />
                </div>
              </Card>
            </div> */}

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {" "}
                  {this.props.t("Rejected List")}{" "}
                </h2>
              </div>
              <Card className="mt-4">
                <BootstrapTable
                  remote
                  keyField="id"
                  headerClasses="fs-5"
                  bordered={false}
                  striped={false}
                  // expandRow={expandRow2}
                  data={this.state.rejectStockList}
                  columns={this.columns2}
                />
              </Card>
            </div>
            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Jangad Rejected By Filler")}
                </h2>
              </div>
              <Card className="mt-4">
                <BootstrapTable
                  remote
                  keyField="id"
                  headerClasses="fs-5"
                  bordered={false}
                  striped={false}
                  // expandRow={expandRow4}
                  data={this.state.fillerRejectStockList}
                  columns={this.columns4}
                />
              </Card>
            </div>
            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Repeat Inward List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.repeatStockList}
                    columns={this.columns5}
                  />
                </div>
              </Card>
            </div>

            <div className="row px-3 pt-4">
              <div>
                <h2 className="fw-bold pb-3 text-black">
                  {this.props.t("Repeat Reject Inward List")}
                </h2>
              </div>
              <Card className="mt-4">
                <div className="table-responsive">
                  <BootstrapTable
                    remote
                    keyField="id"
                    headerClasses="fs-5"
                    bordered={false}
                    striped={false}
                    data={this.state.repeatRejectStockList}
                    columns={this.columns6}
                  />
                </div>
              </Card>
            </div>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
export default withTranslation()(GraderDashboard);
